import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

export const fetchTickets = createAsyncThunk("support/fetch", async () => {
  try {
    const res = await api.get("/support");
    return res.data.tickets;
  } catch (err) {
    throw new Error(err?.response?.data?.error || "Error fetching tickets");
  }
});

export const createTicket = createAsyncThunk(
  "support/create",
  async (ticketData, { rejectWithValue }) => {
    try {
      const res = await api.post("/support", ticketData);
      return res.data.ticket;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.error || "Error creating support request"
      );
    }
  }
);

const supportSlice = createSlice({
  name: "support",
  initialState: { items: [], loading: false, creating: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTickets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Error fetching tickets";
      })
      .addCase(createTicket.fulfilled, (state, action) => {
        state.creating = false;
        state.error = null;
        state.items.unshift(action.payload);
      })
      .addCase(createTicket.pending, (state) => {
        state.creating = true;
        state.error = null;
      })
      .addCase(createTicket.rejected, (state, action) => {
        state.creating = false;
        state.error = action.payload || action.error.message || "Error creating support request";
      });
  },
});

export default supportSlice.reducer;
